export const commonStyles = (FOUNDATIONS, FONT) => ({
    container: {
        padding: FOUNDATIONS.spacing_100,
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        flex_shrink: '0',
        border_radius: FOUNDATIONS.radius_1000,
        border_width: FOUNDATIONS.border_75,
        border_style: 'solid',
    },
    icon: {
        width: FOUNDATIONS.size_150,
        height: FOUNDATIONS.size_150,
    },
});
//# sourceMappingURL=commonStyles.js.map